const topics = [
  { name: '街舞大赛', count: '2,340', icon: 'ri-music-line' },
  { name: '歌唱比赛', count: '1,980', icon: 'ri-mic-line' },
  { name: '创意设计', count: '1,650', icon: 'ri-paint-brush-line' },
  { name: '编程竞赛', count: '1,420', icon: 'ri-code-line' },
  { name: '短视频创作', count: '3,120', icon: 'ri-video-line' },
  { name: '摄影大赛', count: '1,280', icon: 'ri-camera-line' },
  { name: '美食大赛', count: '890', icon: 'ri-restaurant-line' },
  { name: 'Cosplay', count: '760', icon: 'ri-user-star-line' },
  { name: '电竞比赛', count: '2,050', icon: 'ri-gamepad-line' },
  { name: '文学创作', count: '540', icon: 'ri-quill-pen-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          大赛类型
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          每日大赛类型全覆盖，快速找到你感兴趣的大赛赛道
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className="group flex items-center gap-2.5 px-4 py-3 rounded-xl border border-background-200/70 bg-background-50 cursor-pointer transition-all duration-200 hover:border-primary-300 hover:bg-primary-50/50"
            >
              <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${topic.icon} text-sm text-secondary-700`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}